import React from "react";
import injectSheet from "react-jss";
import NumberFormat from "react-number-format";

class Budget extends React.Component {
	constructor() {
		super();

		this.state = {
			track: 300,
		};

		this.setTrack = this.setTrack.bind(this);
		this.routToError = this.routToError.bind(this);
		this.handleClick = this.handleClick.bind(this);
	}

	componentDidMount() {
		window.addEventListener("resize", () => this.setTrack());
		window.dispatchEvent(new Event("resize"));
		this.routToError();
	}

	componentWillReceiveProps(nextProps) {
		if (
			nextProps.location.pathname.indexOf(this.props.location.pathname) < 0 ||
			nextProps.budget.ignore !== this.props.budget.ignore ||
			nextProps.budget.totalReached !== this.props.budget.totalReached ||
			nextProps.budget.total !== this.props.budget.total
		) {
			this.routToError();
		}
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.setTrack, false);
	}

	setTrack() {
		if (this.track) {
			this.setState({
				track: this.track.clientWidth,
			});
		}
	}

	routToError() {
		const {
			budget,
			history,
			history: {
				location: { pathname },
			},
		} = this.props;

		if (!budget.ignore && budget.total < budget.totalReached) {
			if (pathname.indexOf("/budget") < 0) {
				history.push("/budget-error");
			}
		}
	}

	handleClick() {
		const {
			budget,
			history,
			history: {
				location: { pathname },
			},
			setBudgetIgnore,
		} = this.props;

		setBudgetIgnore(false);
		if (budget.total < budget.totalReached) {
			if (pathname.indexOf("/budget") < 0) {
				history.push("/budget");
			}
		}
	}

	render() {
		const { budget, classes } = this.props;

		const { track } = this.state;

		const reached = budget.total < budget.totalReached;

		return (
			<div
				className={`${classes.container} ${
					reached && "reached"
				} ${budget.ignore && "ignore"}`}
			>
				<div className={`${classes.labelContainer}`}>
					Budget:
					<NumberFormat
						className={`${classes.amount}`}
						displayType="text"
						prefix=" "
						suffix={` ${budget.currency} `}
						thousandSeparator="'"
						value={budget.total - budget.totalReached}
					/>
					{budget.ignore ? (
						<span
							className={`${classes.budgetIgnore}`}
							role="button"
							tabIndex={0}
							onClick={() => this.handleClick()}
							onKeyDown={() => false}
						>
							(wird ignoriert)
						</span>
					) : (
						<span>
							von
							<NumberFormat
								displayType="text"
								prefix=" "
								suffix={` ${budget.currency} `}
								thousandSeparator="'"
								value={budget.total}
							/>
						</span>
					)}
				</div>
				<div className={`${classes.statusContainer}`}>
					<div
						className={`${classes.statusTrack}`}
						ref={(node) => {
							this.track = node;
						}}
					>
						<div
							className={`${classes.status} total`}
							style={{
								width: `${budget.totalReached * (track / budget.total)}px`,
							}}
						/>
						<div
							className={`${classes.status} auxiliaries`}
							style={{
								width: `${
									(budget.plotPrice + budget.auxiliaries) *
									(track / budget.total)
								}px`,
								borderWidth: `${budget.auxiliaries > 0 ? 3 : 0}px`,
							}}
						/>
						<div
							className={`${classes.status} plot`}
							style={{
								width: `${budget.plotPrice * (track / budget.total)}px`,
							}}
						/>
					</div>
				</div>
			</div>
		);
	}
}

const styles = (theme) => ({
	container: {
		position: "relative",
		margin: "0 auto",
		top: 0,
		width: "100%",
		maxWidth: "300px",
		[theme.media.medium]: {
			display: "block",
		},
		"&.reached $amount": {
			color: theme.colors.main_1,
		},
		"&.reached $status.auxiliaries, &.reached $status.plot": {
			border: "none",
			background: theme.colors.main_1,
		},
		"&.ignore $status, &.ignore $status.auxiliaries, &.ignore $status.plot": {
			border: "none",
			background: theme.colors.secondary_3a,
		},
	},
	labelContainer: {
		fontWeight: "bold",
		fontSize: "0.6em",
		color: theme.colors.secondary_3b,
	},
	budgetIgnore: {
		cursor: "pointer",
		"&:hover": {
			color: theme.colors.main_1,
		},
	},
	amount: {
		color: theme.colors.main_5,
	},
	statusContainer: {
		width: "100%",
		padding: `${theme.sizes.gutter / 4}px 0`,
	},
	statusTrack: {
		position: "relative",
		width: "100%",
		height: "16px",
		borderRadius: "8px",
		overflow: "hidden",
		backgroundColor: `${theme.colors.secondary_3a}`,
	},
	status: {
		position: "absolute",
		top: 0,
		left: 0,
		height: "100%",
		transition: [
			{
				property: "width",
				duration: theme.speed.fast,
				timingFunction: theme.motion.deceleration,
			},
		],
		"&.total": {
			backgroundColor: theme.colors.main_1,
		},
		"&.auxiliaries": {
			borderColor: theme.colors.main_4,
			borderStyle: "solid",
			background: `repeating-linear-gradient(
        225deg,
        ${theme.colors.main_4},
        ${theme.colors.main_4} 8px,
        ${theme.colors.secondary_3c} 8px,
        ${theme.colors.secondary_3c} 10px
      ) fixed`,
		},
		"&.plot": {
			backgroundColor: theme.colors.main_5,
		},
	},
});

export default injectSheet(styles)(Budget);



// WEBPACK FOOTER //
// ./src/modules/budget/components/budgetOverview.jsx